<app-autocomplete-field
  [label]="label()"
  [placeholder]="placeholder()"
  [errorMessage]="errorMessage()"
  [required]="required()"
  [disabled]="disabled()"
  [suggestions]="charities()"
  [optionLabel]="'value'"
  [ariaLabel]="'Charity'"
  [showCaretIcon]="true"
  [showClear]="false"
  (search)="onSearch($event)"
  (optionSelect)="onSelect($event)"
>
  <ng-template #itemTemplate let-charity>
    {{ charity.name }}
  </ng-template>
</app-autocomplete-field>
